<template>
  <BreadCrumb PageTitle="Dossier Transitaire" />
  <TransitaireDossiers/>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";

import TransitaireDossiers from "@/components/Transitaire/TransitaireDossiers.vue";


export default defineComponent({
  name: "TransitaireDossiersPage",
  components: {
    BreadCrumb,
    TransitaireDossiers,
  },
});
</script>